const rentPricingTable = {
    name: 'RENT & PRICING RANGE',
    description: '',
    hasNamesColumn: true,
    headerRow: [],
    mainRows:["Rent PSF","Monthly Rent","Annual Rent","Aggressive","Anticipated","Conservative"],
    rows: {
        'base-rent-psf': {
            name: 'Rent PSF',
            displayName:true,
            hidden: false,
            valueCells: [{
                unit: '$',
                type: 'number',
                editable: true,
                withDecimals: true,
                value: ''
            },
            {
                editable: false,
                getComputedValue() {
                        return ''
                    }
            },
            {
                editable: false,
                getComputedValue() {
                        return ''
                    }
            },
            {
                editable: false,
                getComputedValue() {
                        return ''
                    }
            },
            {
                editable: false,
                getComputedValue() {
                        return ''
                    }
            },
            {
                editable: false,
                getComputedValue() {
                    return { displayValue: 'Cap Rate' };
                }
            },
            {
                unit: '%',
                type: 'number',
                editable: true,
                withDecimals: true,
                value: ''
            }
        ]
        },
        'rent-adjustment': {
            name: 'Rent PSF Change',
            displayName:true,
            hidden: false,
            valueCells: [{
                unit: '$',
                type: 'number',
                editable: true,
                withDecimals: true,
                value: 5
            },
            {
                editable: false,
                getComputedValue() {
                        return ''
                    }
            },
            {
                editable: false,
                getComputedValue() {
                        return ''
                    }
            },
            {
                editable: false,
                getComputedValue() {
                        return ''
                    }
            },
            {
                editable: false,
                getComputedValue() {
                        return ''
                    }
            },
            {
                editable: false,
                getComputedValue() {
                    return { displayValue: 'BPS Change' };
                }
            },
            {
                unit: '%',
                type: 'number',
                editable: true,
                withDecimals: true,
                value: 0.25
            },
        ]
        },
        'price-percentages': {
            name: 'Rent PSF',
            displayName:true,
            hidden: true,
            valueCells: [
            {
                    editable: false,
                    value: '',
                    getComputedValue() {
                        return ''
                    }
            },
            {
                    editable: false,
                    value: '',
                    getComputedValue() {
                        return ''
                    }
            },
            {
                    editable: false,
                    value: '',
                    getComputedValue() {
                        return ''
                    }
            },
            {
                unit: '%',
                type: 'number',
                editable: true,
                withDecimals: true,
                value: ''
            },
            {
                unit: '%',
                type: 'number',
                editable: true,
                withDecimals: true,
                value: ''
            },
            {
                unit: '%',
                type: 'number',
                editable: true,
                withDecimals: true,
                value: ''
            }
        ]
        },
        'value': {
            name: 'Rent PSF',
            displayName:false,
            generalGetComputedValue(tables, rentPsfMultiplier,precomputedValues) {
                const rent_psf = +tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[0].value;
                const psf_adjustment = +tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[0].value
                const value = parseFloat(rent_psf + (rentPsfMultiplier*psf_adjustment));
                const displayValue = !value || isNaN(value) ? '-' : value < 0 ? `($${(value.toLocaleString(undefined,{ minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace("-",""))})`: `$${value.toLocaleString(undefined,{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                return {internalValue: value, displayValue , precomputedValues};
            },
            valueCells: ([...new Array(7)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    getComputedValue(tables,data,precomputedValues) {
                        return tables['pricing-rent-matrix'].rows['value'].generalGetComputedValue(tables, -3+index,precomputedValues);
                    }
                }
            }),
        },
        'monthly-rent': {
            name: 'Monthly Rent',
            displayName:false,
            generalGetComputedValue(tables, index,precomputedValues) {
                const annualRent = parseFloat(tables['pricing-rent-matrix'].rows['annual-rent'].valueCells[index].getComputedValue(tables,'',precomputedValues).internalValue);
                const value = parseFloat(annualRent / 12).toFixed(2);
                const displayValue = formatDisplayValue(value)
                return {internalValue: value, displayValue};
            },
            valueCells: ([...new Array(7)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    getComputedValue(tables,data,precomputedValues) {
                        return tables['pricing-rent-matrix'].rows['monthly-rent'].generalGetComputedValue(tables,index,precomputedValues);
                    }
                }
            }),
        },
        'annual-rent': {
            name: 'Annual Rent',
            displayName:false,
            generalGetComputedValue(tables, index,precomputedValues) {
                const rentpsf = parseFloat(tables['pricing-rent-matrix'].rows['value'].valueCells[index].getComputedValue(tables,'',precomputedValues).internalValue);
                const sqft = tables['pricing-rent-matrix'].rows['sqft'].valueCells[0].value
                const value = parseFloat(rentpsf * sqft).toFixed(2);
                const displayValue = formatDisplayValue(value)
                return {internalValue: value, displayValue};
            },
            valueCells: ([...new Array(7)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    getComputedValue(tables,data,precomputedValues) {
                        return tables['pricing-rent-matrix'].rows['annual-rent'].generalGetComputedValue(tables, index,precomputedValues);
                    }
                }
            }),
        },
        'aggressive': {
            name: 'Aggressive',
            displayName:false,
            generalGetComputedValue(tables, index,precomputedValues) {
                const AnnualRentPsf = parseFloat(tables['pricing-rent-matrix'].rows['annual-rent'].valueCells[index].getComputedValue(tables,'',precomputedValues).internalValue);
                const capRate = parseFloat(tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[6].value)
                const aggressiveValue = getCalculatedFormattedValue(AnnualRentPsf,capRate/100);
                const value = parseFloat(aggressiveValue).toFixed(2);
                const displayValue = formatDisplayValue(value)
                return {internalValue: value, displayValue};
            },
            valueCells: ([...new Array(7)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    getComputedValue(tables,data,precomputedValues) {
                        return tables['pricing-rent-matrix'].rows['aggressive'].generalGetComputedValue(tables, index,precomputedValues);
                    }
                }
            }),
        },
        'anticipated': {
            name: 'Anticipated',
            displayName:false,
            generalGetComputedValue(tables, index,precomputedValues) {
                const AnnualRentPsf = parseFloat(tables['pricing-rent-matrix'].rows['annual-rent'].valueCells[index].getComputedValue(tables,'',precomputedValues).internalValue);
                const capRate = parseFloat(tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[6].value)
                const bpsChange = parseFloat(tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value)
                const aniticipatedValue = getCalculatedFormattedValue(AnnualRentPsf,(capRate+bpsChange)/100);
                const value = parseFloat(aniticipatedValue).toFixed(2);
                const displayValue = formatDisplayValue(value)
                return {internalValue: value, displayValue};
            },
            valueCells: ([...new Array(7)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    getComputedValue(tables,data,precomputedValues) {
                        return tables['pricing-rent-matrix'].rows['anticipated'].generalGetComputedValue(tables, index,precomputedValues);
                    }
                }
            }),
        },
        'conservative': {
            name: 'Conservative',
            displayName:false,
            generalGetComputedValue(tables, index,precomputedValues) {
                const AnnualRentPsf = parseFloat(tables['pricing-rent-matrix'].rows['annual-rent'].valueCells[index].getComputedValue(tables,'',precomputedValues).internalValue);
                const capRate = parseFloat(tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[6].value)
                const bpsChange = parseFloat(tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value)
                const conservative = getCalculatedFormattedValue(AnnualRentPsf,(capRate+(bpsChange*2))/100);
                const value = parseFloat(conservative).toFixed(2);
                const displayValue = formatDisplayValue(value)
                return {internalValue: value, displayValue};
            },
            valueCells: ([...new Array(7)]).map((el, index) => {
                return {
                    unit: '$',
                    type: 'number',
                    editable: false,
                    getComputedValue(tables,data,precomputedValues) {
                        return tables['pricing-rent-matrix'].rows['conservative'].generalGetComputedValue(tables, index,precomputedValues);
                    }
                }
            }),
        },

        'sqft': {
            name: 'Sq Ft',
            displayName:true,
            valueCells: [{
                unit: 'SF',
                type: 'number',
                editable: true,
                value: '',
            }]
        },
    },
};

export default rentPricingTable;



function formatDisplayValue(value) {
    const result = !value || isNaN(value) ? '-' : value < 0 ? `($${(Math.round(value).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace("-",""))})`: `$${Math.round(value).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    return result;
}

function getCalculatedFormattedValue(annualRent, percentValue) {
    const divisionResult = annualRent / percentValue;
    const dividedBy5000 = divisionResult / 5000;
    const roundedResult = Math.ceil(dividedBy5000);
    const finalResult = roundedResult * 5000;
    return finalResult;
}